import { SEND_UI_LANGUAGES } from './ui/sendLanguageOptions';
import { isRTL } from './utils';

function bcp47ToOgLocale(bcp47) {
  return String(bcp47).replace(/-/g, '_');
}

function setMetaName(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setMetaProperty(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setJsonLd(scriptId, jsonObject) {
  let el = document.getElementById(scriptId);
  const text = JSON.stringify(jsonObject);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = scriptId;
    document.head.appendChild(el);
  }
  el.textContent = text;
}

function syncHreflangAndCanonical(state) {
  const origin = window.location.origin;
  const pathname = window.location.pathname || '/';
  const qs = new URLSearchParams();
  qs.set('lang', state.locale);
  const canonicalHref = `${origin}${pathname}?${qs.toString()}`;

  let canonical = document.querySelector('link[data-send-canonical="1"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.setAttribute('data-send-canonical', '1');
    document.head.appendChild(canonical);
  }
  canonical.href = canonicalHref;

  document.querySelectorAll('link[data-send-hreflang="1"]').forEach(n => n.remove());

  SEND_UI_LANGUAGES.forEach(({ code }) => {
    const link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = code;
    link.href = `${origin}${pathname}?lang=${encodeURIComponent(code)}`;
    link.setAttribute('data-send-hreflang', '1');
    document.head.appendChild(link);
  });

  const xdef = document.createElement('link');
  xdef.rel = 'alternate';
  xdef.hreflang = 'x-default';
  xdef.href = `${origin}${pathname}?lang=en-US`;
  xdef.setAttribute('data-send-hreflang', '1');
  document.head.appendChild(xdef);

  setMetaProperty('og:url', canonicalHref);
}

/**
 * 与当前语言同步 document title、基础 SEO meta、Open Graph、Twitter Card、JSON-LD。
 * @param {object} state — choo 应用 state（含 translate、locale、baseUrl）
 * @param {{ skipTitle?: boolean }} [opts]
 */
export function syncDocumentSeo(state, opts = {}) {
  if (!state || typeof state.translate !== 'function') {
    return;
  }
  const t = state.translate;
  const title = t('title');
  const desc = t('seoMetaDescription');
  const keywords = t('seoMetaKeywords');
  const siteName = t('-send-short-brand');

  if (!opts.skipTitle) {
    document.title = title;
  }

  document.documentElement.lang = state.locale;
  document.documentElement.dir = isRTL(state.locale) ? 'rtl' : 'ltr';

  setMetaName('description', desc);
  setMetaName('keywords', keywords);

  setMetaProperty('og:title', title);
  setMetaProperty('og:description', desc);
  setMetaProperty('og:type', 'website');
  setMetaProperty('og:site_name', siteName);
  setMetaProperty('og:locale', bcp47ToOgLocale(state.locale));

  setMetaName('twitter:card', 'summary');
  setMetaName('twitter:title', title);
  setMetaName('twitter:description', desc);

  syncHreflangAndCanonical(state);

  const base =
    typeof state.baseUrl === 'string'
      ? state.baseUrl.replace(/\/$/, '')
      : window.location.origin;
  setJsonLd('send-schema-website', {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: title,
    alternateName: siteName,
    description: desc,
    url: `${base}/`,
    inLanguage: state.locale
  });
}
